import { commonUtils } from '../common/index.js';

import { IMigration, TMigrationDirection } from './models/index.js';
import { MigrationTransform } from './transforms/index.js';

export class MigrationEngine {
	constructor(public migrations: IMigration[]) {}
	execute<TOutput extends object = object>(data: object, sourceVersion: string, targetVersion: string): TOutput {
		if (sourceVersion === targetVersion) {
			console.warn(`No applicable migrations, sourceVersion equals targetVersion, ${sourceVersion}`);
			return data as TOutput;
		}
		let migrations = [...this.migrations];
		let sourceIndex = migrations.findIndex((migration) => migration.version === sourceVersion);
		let targetIndex = migrations.findIndex((migration) => migration.version === targetVersion);

		const direction: TMigrationDirection = sourceIndex < targetIndex ? 'up' : 'down';

		if (direction === 'down') {
			migrations = migrations.reverse();
			sourceIndex = migrations.findIndex((migration) => migration.version === sourceVersion);
			targetIndex = migrations.findIndex((migration) => migration.version === targetVersion);
		}

		const applicableMigrations = migrations.filter((migration, migrationIndex) => {
			if (direction === 'up') {
				return migrationIndex > sourceIndex && migrationIndex <= targetIndex;
			}
			if (direction === 'down') {
				return migrationIndex >= sourceIndex && migrationIndex < targetIndex;
			}
		});

		let response: object = commonUtils.deepMergeObjects({}, data);
		for (const migration of applicableMigrations) {
			const { transforms: migrationTransforms } = migration;
			let transforms = [...migrationTransforms];
			if (direction === 'down') {
				transforms = transforms.reverse();
			}
			for (const transform of transforms) {
				const migrationTransform = new MigrationTransform(transform);
				response = migrationTransform.execute(response, direction);
			}
		}
		return response as TOutput;
	}
}
